import { Component, OnInit, Input } from '@angular/core';
import { environment } from './../../../../../../environments/environment';

@Component({
  selector: 'app-header-relatorio-laudo',
  templateUrl: './header-relatorio-laudo.component.html',
  styleUrls: ['./header-relatorio-laudo.component.scss']
})
export class HeaderRelatorioLaudoComponent implements OnInit {

  @Input() consulta;
  @Input() parecer;
  @Input() qrcodeUrl = environment.homeUrl;

  title;
  cabecalho;

  constructor() {
    
  }

  ngOnInit() {
    this.cabecalho = this.consulta;
    this.setStatus();
    this.setTitulo();
  }

  setStatus() {
    this.parecer = this.cabecalho.parecer
    // this.parecer.status = '1';
    // this.parecer.value = 'Sucesso';
  }

  setTitulo() {
    this.title = this.cabecalho.tipoLaudo;
  }

}
